<template>
  <!-- 请选择游戏角色[[ -->
  <TipMatchPopupContainer
    :is-show="privateShow"
    :popup-title="`请选择游戏角色`"
    :is-showpopup-close="canClose"
    :can-touch-remove="canClose"
    @onCancel="dissmissDialog"
  >
    <scroll-view
      v-if="!showEmpty"
      scroll-y="true"
      class="role-list"
    >
      <div
        v-for="(role, index) in roleList"
        :key="index"
        class="role-item"
        @click.stop="changeRole(index)"
      >
        <div
          class="role-info"
        >
          <div class="role-name">
            <p>
              {{ role && role.roleBaseInfo && role.roleBaseInfo.rolename ? role.roleBaseInfo.rolename
                : (role.rolename || '') }}
            </p>
            <p>
              {{ role.laddergrade || '' }}
            </p>
          </div>
          <p>
            {{ curRoleDevice(role) }}
            {{ role.gzoneName || role.extra || '' }}
            {{ curRoleGrade(role) }}
            {{ curRoleLevel(role) }}
          </p>
        </div>
        <!-- 选中：selected -->
        <div
          class="role-select"
          :class="{'selected':mSelectNo === index}"
        />
      </div>
    </scroll-view>
    <div
      v-if="!showEmpty && accountTypeText"
      class="tip-match-account-switch"
      @click="onClickBindAccount"
    >
      {{ accountTypeText }}
      <div class="account-switch iconfont icon-back" />
    </div>
    <!-- <div
      v-if="!showEmpty"
      class="role-tip-btn"
      @click.stop="$emit('onClickSelect', mSelectNo)"
    >
      确认
    </div> -->
    <template
      v-else-if="showEmpty"
    >
      <div
        class="role-tip-wrap"
      >
        <p>
          当前{{ accountText }}账号下无可选择的游戏角色，
          您可前往王者荣耀注册游戏账号
        </p>
      </div>
      <div
        class="role-tip-btn"
        @click.stop="$emit('clickKnow')"
      >
        知道了
      </div>
    </template>
  </TipMatchPopupContainer>
  <!-- 请选择游戏角色]] -->
</template>
<script>
import TipMatchPopupContainer from '@tencent/press-ui/press-popup/press-popup';
import { UserInfo } from '@tencent/pmd-tools/lib/user-info';

export default {
  components: {
    TipMatchPopupContainer,
  },
  props: {
    isModify: {
      type: Boolean,
      default: () => false,
    },
    selectedNRoleIdx: String,
    // 弹窗信息
    roleList: {
      type: Array,
      default: () => ([
        {
          laddergrade: '段位',
          gzoneName: '区服',
          roleBaseInfo: {
            rolename: 'name',
          },
        },
        {
          laddergrade: '段位',
          gzoneName: '区服',
          roleBaseInfo: {
            rolename: 'name',
          },
        },
        {
          laddergrade: '段位',
          gzoneName: '区服',
          roleBaseInfo: {
            rolename: 'name',
          },
        },
      ]),
    },
    selectNo: {
      type: Number,
      default: 0,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    canClose: {
      type: Boolean,
      default: true,
    },
    isBigAccount: {
      type: Boolean,
      default: false,
      desc: '是否是大账号',
    },
  },
  data() {
    return {
      mSelectNo: 0,
      privateShow: false,
    };
  },
  computed: {
    accountText() {
      let res = '';
      if (this.tip_utype === 1) {
        res = 'QQ';
      }
      if (this.tip_utype === 2) {
        res = '微信';
      }
      // #ifdef MP-QQ
      res = 'QQ';
      // #endif
      // #ifdef MP-WEIXIN
      res = '微信';
      // #endif
      return res;
    },
    accountTypeText() {
      if (this.isBigAccount) {
        return '';
      }
      if (UserInfo.tipUtype() === 2) {
        return '绑定QQ账号，添加更多角色';
      }
      if (UserInfo.tipUtype() === 1) {
        return '绑定微信账号，添加更多角色';
      }
      return '';
    },
    curRoleDevice() {
      return (role) => {
        if (Reflect.has(role, 'roleBaseInfo')) {
          if (role?.roleBaseInfo?.device === 2) {
            return '安卓';
          }
          if (role?.roleBaseInfo?.device === 1) {
            return '苹果';
          }
        }
        return '';
      };
    },
    curRoleGrade() {
      return (role) => {
        if (Reflect.has(role, 'roleBaseInfo')) {
          return role?.roleBaseInfo?.rolegrade || '';
        }
        return '';
      };
    },
    curRoleLevel() {
      return (role) => {
        if (Reflect.has(role, 'roleBaseInfo')) {
          return `Lv.${role?.roleBaseInfo?.rolelevel}` || '';
        }
        return '';
      };
    },
  },
  options: {
    virtualHost: true,
  },
  watch: {
    selectNo(newVal) {
      this.mSelectNo = newVal;
    },
    show: {
      handler(val) {
        this.privateShow = val;
      },
      immediate: true,
    },
  },
  mounted() {
    this.mSelectNo = this.selectNo;
  },
  methods: {
    dissmissDialog() {
      if (this.canClose) {
        this.$emit('dissmissDialog');
      }
    },
    changeRole(index) {
      this.mSelectNo = index;
      this.$emit('onClickSelect', this.mSelectNo);
    },
    onClickBindAccount() {
      this.$emit('onClickBindAccount');
    },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss"></style>
